// extracted by mini-css-extract-plugin
export default {"container":"ImageContainer_container__GrDu+","image":"ImageContainer_image__VtO1r"};